import { useMain } from 'screens/Dashboard/containers/Main/useMain'

export const useTeamDescription = () => {
	const [models, operations] = useMain()

	return [models, operations] as [typeof models, typeof operations]
}
